import * as React from "react";
import { forwardRef } from "react";
const SvgComponentViewIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 50 50", style: {
  enableBackground: "new 0 0 50 50"
}, xmlSpace: "preserve", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0,0v50h50V0H0z M21,37h-8v-8h8V37z M21,21h-8v-8h8V21z M37,37h-8v-8h8V37z M37,21h-8v-8h8V21z" }));
const ForwardRef = forwardRef(SvgComponentViewIcon);
export { ForwardRef as ReactComponent };
